<img #captcha title="Нажмите для обновления капчи" [height]="50" [width]="200" (click)="getCaptcha()" />
<button kendoButton iconClass="k-icon k-font-icon k-i-refresh" (click)="getCaptcha()">Обновить</button>
<kendo-textbox placeholder="Введите код" [(ngModel)]="code" (valueChange)="onChangeCode($event)" />
